// extracted by mini-css-extract-plugin
module.exports = {"VideoAnimation":"VideoAnimation_VideoAnimation__AlCOO"};